import useBrandList from 'commons/hooks/use-brand-list';
import { FormLabel } from '../../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { Radio } from 'antd';

const BrandName = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  const { BrandList: brandList } = useBrandList();

  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.brand)}:</FormLabel>
      <Controller
        name={`productList.${index}.brandName`}
        control={control}
        render={({ field }) => (
          <div className="relative w-full">
            <Radio.Group {...field} optionType="button" buttonStyle="solid">
              {brandList.map(({ value, label }) => {
                return (
                  <Radio value={value} key={value}>
                    {label}
                  </Radio>
                );
              })}
            </Radio.Group>
          </div>
        )}
      />
    </div>
  );
};

export default BrandName;
